import { render, staticRenderFns } from "./task.vue?vue&type=template&id=8f66ce0c&scoped=true&"
import script from "./task.vue?vue&type=script&lang=js&"
export * from "./task.vue?vue&type=script&lang=js&"
import style0 from "./task.vue?vue&type=style&index=0&id=8f66ce0c&scoped=true&lang=css&"
import style1 from "./task.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f66ce0c",
  null
  
)

export default component.exports